import { render } from "./nest_notes.vue?vue&type=template&id=6571da06"
import script from "./nest_notes.vue?vue&type=script&lang=js"
export * from "./nest_notes.vue?vue&type=script&lang=js"

import "./nest_notes.vue?vue&type=style&index=0&id=6571da06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__